import { SearchRecord } from '../models/search-results';

export class SubscriptionsUtil {
	// TODO
	// Will make it generic later
	public static initData(data: SearchRecord[]): SearchRecord[] {
		data.forEach((report: SearchRecord) => {
			report.publicationDate = new Date(report.publicationDate);
		});
		return data;
	}
}
